import { Button } from '@fluentui/react-components'
import { Add24Regular, DocumentLandscapeData20Regular, WebAsset20Regular } from '@fluentui/react-icons'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
import { createRestClient } from '@/contexts/QueryProvider'
import { EntityTypeCard } from '../FluentCard/EntityTypeCard'
import { ComposedPopover } from '../Popover/ComposedPopover'
import { DataAssetsList } from '../FluentCard/EntityTypeCard/DataAssetsList'
import { EntityCardActionsMenu } from '../FluentCard/EntityTypeCard/EntityCardActionsMenu'
import { FileTemplatesList } from '../FluentCard/EntityTypeCard/FileTemplatesList'
import { AddEntityTypeForm } from '../Forms/AddEntityTypeForm'
import { OverlayDrawerComponent } from '../OverlayDrawerComponent/OverlayDrawerComponent'

type AppEntityTypesPanelProps = {
  applicationId: number
}

export const AppEntityTypesPanel = ({ applicationId }: AppEntityTypesPanelProps) => {
  const queryClient = useQueryClient()
  const { getEntityTypeApiGetEntityTypesByApplicationId } = createRestClient()

  const {
    data: entityTypes,
    // isPending,
    // isError,
  } = getEntityTypeApiGetEntityTypesByApplicationId.useQuery({
    path: { applicationId },
  })

  const invalidateEntityTypes = useCallback(() => {
    getEntityTypeApiGetEntityTypesByApplicationId.invalidateQueries(
      { parameters: { path: { applicationId } } },
      queryClient
    )
  }, [applicationId, getEntityTypeApiGetEntityTypesByApplicationId, queryClient])

  const [isAddEntityTypeOpen, setIsAddEntityTypeOpen] = useState<boolean>(false)

  return (
    <div>
      <div className="flex items-center justify-between border-b pb-1">
        <div>
          <h5>Entity types</h5>
          <p>Manage the entity types for your application below.</p>
        </div>
        <Button appearance="transparent" icon={<Add24Regular />} onClick={() => setIsAddEntityTypeOpen(true)}></Button>
      </div>

      {/* <div className="card-container" style={{ border: '1px solid #ccc', padding: '1rem', borderRadius: '2px' }}> */}
      <div className="grid grid-cols-1 gap-4 py-3 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
        {entityTypes?.map((entityType) => (
          <EntityTypeCard
            key={entityType.id}
            name={entityType.name}
            description={entityType.description}
            cardMenu={<EntityCardActionsMenu entityType={entityType} />}
            fileTemplatesListPopover={
              <ComposedPopover
                trigger={
                  <Button size="small" icon={<WebAsset20Regular />}>
                    File templates
                  </Button>
                }
              >
                <FileTemplatesList entityType={entityType} applicationId={applicationId} />
              </ComposedPopover>
            }
            dataAssetsListPopover={
              <ComposedPopover
                trigger={
                  <Button size="small" icon={<DocumentLandscapeData20Regular />}>
                    Data assets
                  </Button>
                }
              >
                <DataAssetsList entityType={entityType} applicationId={applicationId} />
              </ComposedPopover>
            }
          />
        ))}
      </div>

      {/* Add Entity Type Drawer */}
      <OverlayDrawerComponent
        open={isAddEntityTypeOpen}
        size="medium"
        setOpen={setIsAddEntityTypeOpen}
        title="Add Entity Type"
        content={
          <AddEntityTypeForm
            applicationId={applicationId}
            onSubmit={() => {
              setIsAddEntityTypeOpen(false)
              invalidateEntityTypes()
            }}
          />
        }
      />
    </div>
  )
}
